import { memo } from "react";

import TableHead from "ds/components/Table/Head";
import { getColumnKey } from "ds/components/Table/Head/Column/utils";
import { SortStateDescriptor } from "components/Filters/types";
import TableSettings from "ds/components/Table/Settings";
import { CONTEXTS_COLUMN_ID } from "views/Account/Contexts/constants";

import useContextsTableStore from "../useContextsTableStore";
import { selectVisibleColumns } from "../useContextsTableStore/selectors";
import ContextsTableHeadColumn from "./Column";
import { showTableSettingsDrawer } from "./Drawer";

type ContextsTableHeadProps = {
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const ContextsTableHead = ({ sortCallback }: ContextsTableHeadProps) => {
  const columns = useContextsTableStore((state) => selectVisibleColumns(state));

  return (
    <TableHead>
      {columns.map((column) => (
        <ContextsTableHeadColumn
          key={getColumnKey(column)}
          sortCallback={sortCallback}
          column={column}
        >
          {column.id === CONTEXTS_COLUMN_ID.DROPDOWN && (
            <TableSettings title="Contexts actions" onPress={showTableSettingsDrawer} />
          )}
        </ContextsTableHeadColumn>
      ))}
    </TableHead>
  );
};

export default memo(ContextsTableHead);
